const refs = {
  logoHome: document.querySelector('.site-logo'),
  home: document.querySelector('#nav-home'),
  container: document.querySelector('#container'),
  serchForm: document.querySelector('.search-form'),
  textArea: document.querySelector('#search-form'),
  cardContainer: document.querySelector('#container'),
  cardList: document.querySelector('.card_list'),
  library: document.querySelector('#nav-library'),
  sidebar: document.querySelector('.sidebar'),
  sidebarWatchBtn: document.querySelector('.sidebar_watch'),
  sidebarQueueBtn: document.querySelector('.sidebar_queue'),
  loadMoreBtn: document.querySelector('.loadMoreBtn'),
  cardListItem: document.querySelector('.itemCard'),
  pagination: document.querySelector('.pagination'),
  paginationNumber: document.querySelector('.pagination-page--number'),
  libraryPageList: document.querySelector('.library-page__list'),
  libraryPageSection: document.querySelector('.library-page'),
  sidebar: document.querySelector('.sidebar'),
  sidebarWatch: document.querySelector('.sidebar_watch'),
  watchButton: document.querySelector('.sidebar_watch-button'),
  sidebarQueue: document.querySelector('.sidebar_queue'),
  queueButton: document.querySelector('.sidebar_queue-button'),
  cardContainer: document.querySelector('.card_container'),
};
export default refs;
